import { Button as MuiButton, alpha, makeStyles } from "@material-ui/core";
import cns from "classnames";
import { ComponentProps } from "react";

export type ButtonProps = Omit<ComponentProps<typeof MuiButton>, "color"> & {
  color?: ComponentProps<typeof MuiButton>["color"] | "tertiary";
};

/**
 * @deprecated use regular Button from mui
 * @param props
 * @constructor
 */
export function Button(props: ButtonProps) {
  const { className, color, ...rest } = props;
  const classes = useStyles({});

  const customClass = (() => {
    if (color !== "tertiary") return undefined;
    switch (rest.variant) {
      case "contained":
        return classes.containedTertiary;
      case "outlined":
        return classes.outlinedTertiary;
      case "text":
        return classes.textTertiary;
      default:
        return undefined;
    }
  })();

  return (
    <MuiButton
      className={cns(customClass, className)}
      color={color === "tertiary" ? "primary" : color}
      {...rest}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  textTertiary: {
    color: theme.palette.tertiary.main,
    "&:hover": {
      color: theme.palette.tertiary.dark,
      backgroundColor: "transparent",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  },
  outlinedTertiary: {
    color: theme.palette.tertiary.main,
    border: `1px solid ${alpha(theme.palette.tertiary.main, 0.5)}`,
    boxShadow: "0px 8px 24px 0px rgba(128, 128, 128, 0.15)",
    "&:hover": {
      border: `1px solid ${theme.palette.tertiary.main}`,
      backgroundColor: alpha(
        theme.palette.tertiary.main,
        theme.palette.action.hoverOpacity
      ),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  },
  containedTertiary: {
    color: theme.palette.tertiary.contrastText,
    backgroundColor: theme.palette.tertiary.main,
    boxShadow: "0px 8px 24px 0px rgba(128, 128, 128, 0.15)",
    "&:hover": {
      backgroundColor: theme.palette.tertiary.dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: theme.palette.tertiary.main
      }
    }
  }
}));

export default Button;
